import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import cardEVIO from "../../../styles/images/ceme/cardEVIO.png";
import "../../../styles/components/ceme/sections/Default.scss";
import Card from "./Card";
class Default extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      translationKeys: [],
    };
  }

  //Splits data by ";" to make sure <span> and <p> are done in the render
  handleTranslationKeys() {
    const array = I18n.t("siteCeme_intro").split(";");
    this.safeSetState({ translationKeys: array });
  }

  componentDidMount() {
    this._mounted = true;
    this.handleTranslationKeys();
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="default">
        <div className="content-section">
          <div className="content">
            <div className="item top">
              <div className="title">ADESÃO</div>
              <div className="sub-title">CARREGAMENTO SEM COMPLICAÇÕES</div>
            </div>
            <div className="item left-side">
              <div className="text">
                <p>
                  {this.state.translationKeys.map((item, idx) => {
                    return <span key={idx}>{item}</span>;
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Card />
      </div>
    );
  }
}

export default Default;
